import { EquipmentTable } from "@/modules/equipment/components/EquipmentTable";

interface OrgEquipmentTabProps {
	organizationId: string;
}

export function OrgEquipmentTab({ organizationId }: OrgEquipmentTabProps) {
	return <EquipmentTable organizationId={organizationId} />;
}
